export default {
  SET_MY_ROOMS: (state, rooms) => {
    state.myRooms = rooms;
  },

  SET_LOADING: (state, loading) => {
    state.loading = loading;
  },

  SET_ERROR: (state, error) => {
    state.error = error;
  },
};
